import { IntegrationSystem } from "../../types";
import { KlaviyoConnectView } from "./connect-view";
import { KlaviyoSettingsView } from "./settings-view";

export const KlaviyoSystem: IntegrationSystem = {
  ConnectView: KlaviyoConnectView,
  SettingsView: KlaviyoSettingsView
};

export { klaviyoIntegrationReducer } from "./redux";
